import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="menu"
export default class extends Controller {
  static targets = ["button", "dropdown"]
    connect() {
        this.dropdownTarget.classList.add("hidden")
        this.dropdownTarget.classList.remove(
            "opacity-100",
            "scale-100",
            "opacity-0",
            "scale-95",
            "ease-in",
            "ease-out",
        )
    }

    toggleMenu(event) {
        event.preventDefault();
        this.dropdownTarget.classList.toggle("hidden")
    }

    hide(event) {
        if (event && (this.dropdownTarget.contains(event.target) || this.buttonTarget.contains(event.target))) {
            return;
        }
        if (event) {
            this.dropdownTarget.classList.add("hidden")
        }
    }

    show(event) {
        if (event && (this.dropdownTarget.contains(event.target) || this.buttonTarget.contains(event.target))) {
            return;
        }
    }

    isActive() {
        return this.buttonTarget.getAttribute("aria-expanded") === "true"
    }
}


